// Revival header helpers: keeps every "Shopping as" control's label in sync with the stored customer type,
// closes the dropdown after a choice, and wires "Show everything".
(function () {
  if (window.__rvHeader) return; window.__rvHeader = true;
  var LABELS = { 'dog-breeder': 'Dog Breeder', 'cat-breeder': 'Cat Breeder', 'shelter': 'Shelter or Rescue', 'equine': 'Equine', 'vet': 'Vet Clinic' };
  function current() { return (window.RevivalCT && window.RevivalCT.get()) || document.documentElement.getAttribute('data-customer-type') || ''; }
  function paint(type) {
    document.querySelectorAll('[data-rv-shopas]').forEach(function (d) {
      var v = d.querySelector('[data-rv-shopas-value]');
      if (v) v.textContent = LABELS[type] || 'Choose';
      d.classList.toggle('is-set', !!type);
      var clear = d.querySelector('[data-rv-shopas-clear]');
      if (clear) clear.hidden = !type;
    });
  }
  document.addEventListener('revival:customer-type', function (e) {
    paint((e.detail && e.detail.type) || '');
    document.querySelectorAll('[data-rv-shopas][open]').forEach(function (d) { d.removeAttribute('open'); });
  });
  document.addEventListener('click', function (e) {
    var t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    if (t.closest('[data-rv-shopas-clear]') && window.RevivalCT) { window.RevivalCT.set(''); return; }
    // Close open dropdowns when clicking elsewhere.
    document.querySelectorAll('[data-rv-shopas][open]').forEach(function (d) { if (!d.contains(t)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('[data-rv-shopas][open]').forEach(function (d) { d.removeAttribute('open'); d.querySelector('summary').focus(); });
  });
  // Teaser: for visitors with no type yet, show the one-click picker under the control a few seconds after load.
  // At most once per browser session and 3 sessions in total; never on cart/account pages; gone once dismissed or chosen.
  var TIP_KEY = 'revival_ct_tip';
  function tipState() { try { return JSON.parse(localStorage.getItem(TIP_KEY)) || {}; } catch (e) { return {}; } }
  function saveTip(s) { try { localStorage.setItem(TIP_KEY, JSON.stringify(s)); } catch (e) {} }
  function hideTip(reason) {
    document.querySelectorAll('[data-rv-shopas-tip]').forEach(function (el) { el.hidden = true; });
    if (reason === 'dismiss') { var s = tipState(); s.dismissed = true; saveTip(s); }
  }
  function maybeTip() {
    if (current() || /^\/(cart|account|checkout)/.test(location.pathname)) return;
    var tip = document.querySelector('[data-rv-shopas-tip]');
    if (!tip || window.matchMedia('(max-width: 749px)').matches) return;
    var s = tipState();
    if (s.dismissed || (s.shown || 0) >= 3) return;
    try { if (sessionStorage.getItem(TIP_KEY)) return; sessionStorage.setItem(TIP_KEY, '1'); } catch (e) {}
    setTimeout(function () {
      if (current() || document.querySelector('[data-rv-shopas][open]')) return;
      s.shown = (s.shown || 0) + 1; saveTip(s);
      tip.hidden = false;
      track('revival_shopas_teaser_shown', {});
      setTimeout(function () { tip.hidden = true; }, 15000);
    }, 3500);
  }
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    if (t.closest('[data-rv-shopas-tip-close]')) { hideTip('dismiss'); track('revival_shopas_teaser_dismissed', {}); return; }
    var opt = t.closest('[data-ct-option]');
    if (opt) {
      var src = opt.getAttribute('data-ct-source') || (opt.closest('[data-rv-shopas]') ? 'header' : 'page');
      track('revival_customer_type_selected', { customer_type: opt.getAttribute('data-ct-option'), source: src });
      hideTip();
    }
    if (t.closest('[data-rv-shopas] summary')) hideTip();
  }, true);
  function boot() { paint(current()); maybeTip(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
